import { type FC } from 'react';
import { SimpleGrid } from '@mantine/core';
import { IconCreditCard } from '@tabler/icons-react';
import { PayinPaymentMethod } from '~/entities/payin';
import { SbpIcon } from '~/shared/icons/SbpIcon';
import { type CreateOrderPaymentMethod } from '../../actions';
import { Action, type ActionItem } from './components';

interface ActionsProps {
    onCreate: (paymentMethod: CreateOrderPaymentMethod) => void;
}

const createOrderActions: ActionItem[] = [
    {
        method: PayinPaymentMethod.METHOD_SBP,
        title: 'Создать СБП',
        description: 'Прием платежей через систему быстрых платежей',
        icon: SbpIcon,
    },
    {
        method: PayinPaymentMethod.METHOD_CARD,
        title: 'Создать карты',
        description: 'Прием платежей по банковским картам',
        icon: IconCreditCard,
    },
] as const;

export const Actions: FC<ActionsProps> = ({ onCreate }) => {
    return (
        <SimpleGrid
            cols={{
                base: 1,
                sm: 2,
            }}
            spacing='md'
        >
            {createOrderActions.map((props) => {
                return (
                    <Action
                        key={props.method}
                        onCreate={onCreate}
                        {...props}
                    />
                );
            })}
        </SimpleGrid>
    );
};
